import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import moment from "moment";
import styled from "styled-components";

import { BackButton, Title, HeaderContainer } from "components";
import { CrearGrupoForm } from "components/Forms";
import { useGetGrupo } from "hooks/useRequest";
import { editarGrupo } from "./mutation";
import { Mutation } from "hooks/useMutation";
import { isEidu } from "utilites/periodoTypes";

export default function EditarGrupo() {
  const history = useHistory();
  const { search } = useLocation();

  const mutation = Mutation(editarGrupo);

  const { grupo } = queryString.parse(search);

  const { data, remove } = useGetGrupo({
    //@ts-ignore
    id: parseInt(grupo),
  });

  const isEiduPeriodo = isEidu(data?.periodoMatricula?.tipoPeriodo?.id);

  const initialValues = data
    ? {
        name: data.nombre,
        qty: data.cupo,
        ...(isEiduPeriodo
          ? {}
          : {
              type: data.tipoSede,
              day: data.horario,
              startTime: moment(data.horaEntrada, "h:mm a"),
              endTime: moment(data.horaSalida, "h:mm a"),
            }),
        profesor: data.nombreProfesor,
      }
    : null;

  const onFinish = (values: any) => {
    const formattedValues = {
      id: data.id,
      nombre: values.name,
      horario: isEiduPeriodo ? "" : values.day,
      tipoSede: isEiduPeriodo ? false : values.type,
      cupo: values.qty,
      profesor: values.profesor,
      horaEntrada: isEiduPeriodo
        ? ""
        : moment(values.startTime).format("h:mm a"),
      horaSalida: isEiduPeriodo
        ? ""
        : moment(values.endTime).format("h:mm a"),
    };
    /*@ts-ignore*/
    mutation.mutate(formattedValues);
    goBack();
  };

  const goBack = () => {
    history.push({
      pathname: "/admin/periodo-matricula",
      search: `?periodo=${data.periodoMatricula.id}`,
    });
    remove();
  };

  return (
    <PageContainer>
      <HeaderContainer>
        <BackButton text="Inicio" onClick={() => goBack()} link="/admin" />
      </HeaderContainer>
      {data && (
        <>
          <Title title={`Editar ${initialValues?.name}`} />
          <CrearGrupoForm
            initialValues={initialValues}
            onCancel={goBack}
            onFinish={onFinish}
            submitButtonText={isEiduPeriodo ? "Actualizar Taller" : "Actualizar Grupo"}
            isEidu={isEiduPeriodo}
          />
        </>
      )}
    </PageContainer>
  );
}

const PageContainer = styled.div`
  @media (min-width: 768px) {
    margin-bottom: 45px;
    padding-right: 86px;
    padding-left: 86px;
  }
`;
